/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import {
  call, put, takeLatest,
} from 'redux-saga/effects';
import { actions } from 'Slice/AlertsSlice';
import { actions as SearchContentActions } from 'Slice/GlobalSearchContentSlice';
import { actions as helperActions } from 'Slice/HelperSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'Utils/Axios';
import { API, FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS } from 'Utils/Constants';
import {
  AlertsArticlesRequest, AlertsArticlesResponse,
  AlertsNotificationPulseResponse,
  ExportNotificationHighlightsRequest,
  ExportNotificationHighlightsResponse,
  NotificationAlertRequest, NotificationAlertsResponse, NotificationHighlightsRequest, NotificationHighlightsResponse, NotificationOpendResponse,
  NotificationOpenedRequest,
  NotificationPulseRequest,
} from 'Types/CompaniesTypes';
import { Base64 } from 'js-base64';

export function* getAlertArticles(dispatched: PayloadAction<AlertsArticlesRequest>) {
  try {
    const payload = dispatched?.payload;
    const data: object = {
      page: payload.page,
      ...payload.filter.length > 0 && { filter: payload.filter.map((it) => it.filterId).join(',') },
      ...payload.company.length > 0 && { companyids: payload.company.map((c) => c.companyId).join(',') },
      resetcount: 'True',
    };
    const response: AlertsArticlesResponse = yield call(
      axios.post,
      API.GET_NOTIFICATIONS_ALERTS,
      data,
    );
    if (response?.status === true) {
      if (dispatched?.payload?.page !== 1) {
        yield put(actions.setMoreAlertArticles(response?.response));
      } else {
        yield put(actions.setAlertArticles(response?.response));
        yield put(SearchContentActions.updateArticleCount(response?.response?.notificationCount));
      }
      if (response?.response?.articles?.length < 1) {
        yield put(actions.setArticlesEnded());
      }
    }
  } catch (err) {
    console.log(err);
  }
}

export function* getNotificationPulse(dispatched: PayloadAction<NotificationPulseRequest>) {
  try {
    const response: AlertsNotificationPulseResponse = yield call(
      axios.post,
      API.GET_NOTIFICATIONS_PULSE,
      dispatched?.payload,
    );
    if (response?.status === true) {
      yield put(actions.setNotificationPulse(response?.response))
    }
  } catch (err) {
    console.log(err);
  }

}

export function* getNotificationAlerts(dispatched: PayloadAction<NotificationAlertRequest>) {
  try {
    const payload = dispatched?.payload;
    const data: object = {
      username: payload.username,
      page: payload.page,
      ...payload.filter.length > 0 && { filter: payload.filter.map((it) => it.filterId).join(',') },
    };
    const response: NotificationAlertsResponse = yield call(
      axios.post,
      API.GET_PERSON_DESIGNATION_ALERT,
      data,
    );
    if (response?.status === true) {
      if (dispatched?.payload?.isNotes) {
        if (dispatched.payload?.page !== 1) {
          yield put(actions.setMoreNotesAlerts(response?.response));
        } else if (response.response.notifications.length) {
          yield put(actions.setNotesAlerts(response?.response));
        } else {
          yield put(actions.setNotesMessage(response?.message || ''));
        }
        if (response?.response?.notifications?.length < 1) {
          yield put(actions.setNotesEnded());
        }
      } else {
        if (dispatched?.payload?.page !== 1) {
          yield put(actions.setMoreNotificationAlerts(response?.response));
        } else if (response.response.notifications.length) {
          yield put(actions.setNotificationAlerts(response?.response));
          yield put(SearchContentActions.updatePeopleCount(response?.response?.notificationCount));
        } else {
          yield put(actions.setNotificationMessage(response?.message || ''));
        }
        if (response?.response?.notifications?.length < 1) {
          yield put(actions.setNotificationAlertsEnded());
        }
      }
    } else {
      yield put(actions.notificationAlertsError());
    }
  } catch (error) {
    yield put(actions.notificationAlertsError());
    console.log('error', error);
  }
}
export function* getFeedNotificationAlerts(dispatched: PayloadAction<NotificationAlertRequest>) {
  try {
    const payload = dispatched?.payload;
    const data: object = {
      username: payload.username,
      page: payload.page,
      ...payload.filter.length > 0 && { filter: payload.filter.map((it) => it.filterId).join(',') },
      ...payload.isGilroyInsight && { isGilroyInsight: payload.isGilroyInsight },
      ...payload.priorityFilter && { priorityFilter: payload.priorityFilter.map((it) => it).join(',') },
    };
    const response: NotificationAlertsResponse = yield call(
      axios.post,
      API.GET_PERSON_DESIGNATION_ALERT,
      data,
    );
    if (response?.status === true) {
      if (dispatched?.payload?.page !== 1) {
        yield put(actions.setFeedMoreNotificationAlerts(response?.response));
      } else if (response.response.notifications.length) {
        yield put(actions.setFeedNotificationAlerts(response?.response));
      } else {
        yield put(actions.setFeedNotificationMessage(response?.message || ''));
      }
      if (response?.response?.notifications?.length < 1) {
        yield put(actions.setFeedNotificationAlertsEnded());
      }
    } else {
      yield put(actions.feedNotificationAlertsError());
    }
  } catch (error) {
    yield put(actions.feedNotificationAlertsError());
    console.log('error', error);
  }
}
export function* getNotificationOpened(dispatched: PayloadAction<NotificationOpenedRequest>) {
  try {
    const payload = dispatched?.payload;
    const response: NotificationOpendResponse = yield call(
      axios.post,
      API.GET_NOTIFICATION_OPENED,
      payload,
    );
    if (response?.status === true) {
      if (payload.id !== undefined) {
        yield put(actions.setNotificationOpened(payload.id));
      }
    }
  } catch (error) {
    console.log('error', error);
  }
}
export function* getFeedNotificationOpened(dispatched: PayloadAction<NotificationOpenedRequest>) {
  try {
    const payload = dispatched?.payload;
    const response: NotificationOpendResponse = yield call(
      axios.post,
      API.GET_NOTIFICATION_OPENED,
      payload,
    );
    if (response?.status === true) {
      if (payload.id !== undefined) {
        yield put(actions.setFeedNotificationOpened(payload.id));
      }
    }
  } catch (error) {
    console.log('error', error);
  }
}

export function* getNotificationHighlights(dispatched: PayloadAction<NotificationHighlightsRequest>) {
  try {
    const payload = dispatched?.payload;
    const data: object = {
      notificationId: payload.notificationId,
      page: payload.page,
      ...(payload.prompt ? { prompt: Base64.encode(payload.prompt) } : {}),
      ...(payload.refresh ? { refresh: payload.refresh } : {}),
    };
    const response: NotificationHighlightsResponse = yield call(
      axios.post,
      API.GET_NOTIFICATION_HIGHLIGHTS,
      data,
    );
    if (response) {
      yield put(actions.setNotificationHighlights(response));
    }
  } catch (error) {
    console.log('error', error);
  }
}

export function* exportNotificationHighlights(dispatched: PayloadAction<ExportNotificationHighlightsRequest>) {
  try {
    const payload = dispatched?.payload;
    const data = {
      timeRange: payload.timeRange,
      ...(payload.priorityFilter ? { priorityFilter: payload.priorityFilter } : {}),
    };

    const response: ExportNotificationHighlightsResponse = yield call(
      axios.post,
      API.EXPORT_NOTIFICATION_HIGHLIGHTS,
      data,
    );

    if (response?.status === true && response?.response?.url) {
      yield put(actions.setExportNotificationHighlights(response));

      const newWin = window.open(response.response.url);
      if (newWin) {
        yield put(helperActions.setNotification({
          message: FILE_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        yield put(helperActions.setNotification({
          message: FILE_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
    } else {
      yield put(actions.exportNotificationHighlightsError());
      yield put(helperActions.setNotification({
        message: response?.message || FILE_DOWNLOAD_FAIL,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  } catch (error) {
    yield put(actions.exportNotificationHighlightsError());
    yield put(helperActions.setNotification({
      message: FILE_DOWNLOAD_FAIL,
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: false,
    }));
    console.log('error', error);
  }
}


export function* alertsSaga() {
  yield takeLatest(actions.getAlertArticles.type, getAlertArticles);
  yield takeLatest(actions.getNotificationAlerts.type, getNotificationAlerts);
  yield takeLatest(actions.getFeedNotificationAlerts.type, getFeedNotificationAlerts);
  yield takeLatest(actions.getNotificationOpened.type, getNotificationOpened);
  yield takeLatest(actions.getFeedNotificationOpened.type, getFeedNotificationOpened);
  yield takeLatest(actions.getNotificationHighlights.type, getNotificationHighlights);
  yield takeLatest(actions.exportNotificationHighlights.type, exportNotificationHighlights);
  yield takeLatest(actions.getNotificationPulse.type, getNotificationPulse);
}
